export { default } from "bullitttime-embermodelsevent/models/mass-start-class-group-association";
